import React from 'react'
import clsx from 'clsx'
import kebabCase from 'lodash.kebabcase'
import { Button } from '@/components/atoms/Button/Button'
import { RichTextField } from '@/components/organisms/RichTextField/RichTextField'
import { ReactComponent as Line } from '@/assets/icons/wavy_line.svg'
import { CaseStudyCTAProps } from './types'

export function CaseStudyCTA({ pageContent, instance, ...props }: CaseStudyCTAProps) {
  const { content } = pageContent?.blok || instance || {}
  const { heading, body, buttons, variant = 'default' } = content || props

  return (
    <section
      className={clsx('relative rounded-xl mb-40 mx-24 netbook:mx-0 overflow-hidden', {
        'bg-text-brand-darker': variant === 'default',
        'bg-primary-100': variant === 'light'
      })}
      id={kebabCase(heading)}
    >
      <Line className="absolute top-0 left-0 w-full z-0 rotate-3 opacity-10" />
      <Line className="absolute -bottom-20 -right-1/3 -rotate-3 w-full z-0 opacity-10" />
      <div
        className="flex flex-col *:z-[5] p-24 netbook:p-40 gap-24 mx-auto
    tablet:flex-row netbook:items-center netbook:justify-between max-w-screen-desktop"
      >
        <div
          className={clsx('max-w-[437px]', {
            'text-white ': variant === 'default',
            'text-text-brand-darker': variant === 'light'
          })}
        >
          <h2 className="text-headingM-mobile netbook:text-headingM font-bold mb-12 font-poppins">{heading}</h2>
          <div className="leading-loose text-bodyL font-normal font-sans netbook:max-w-lg text-grey-100">
            {typeof body === 'string' ? body : <RichTextField data={body} />}
          </div>
        </div>
        <div className="z-10 flex flex-col tablet:items-center tablet:justify-center flex-grow netbook:flex-row gap-16 netbook:gap-24">
          {buttons &&
            buttons?.length > 0 &&
            buttons.map((button) => (
              <Button key={button._uid} {...button} theme={button.theme} className="w-full netbook:w-auto">
                {button.text}
              </Button>
            ))}
        </div>
      </div>
    </section>
  )
}
